import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

if (window.debugLog) window.debugLog('main.jsx: Executing');

try {
    ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    )
    if (window.debugLog) window.debugLog('main.jsx: Render called');
} catch (e) {
    if (window.debugLog) window.debugLog('main.jsx ERROR: ' + e.message, '#ff3333');
}
